import React from "react"
import styled from "styled-components"
import {Row, Col} from "antd";
import ImageText from "../text/ImageText";
import useTranslation from "../../utils/translation";
import {useNavigate} from "react-router-dom";
import {useLocale} from "../../context/AppContext";

const GridWrapper = styled.div`
  margin-top: 50px;
`

const ImageWrapper = styled.div`
  display: flex;
  justify-content: ${p => p.center ? "center" : "inherit"};
`
const TextWrapper = styled.div``

const ImageGrid = ({object, type, imageStyle, wrapperStyle, itemsPerRow, centerText = false, centerImage = false, smallText = true, textTranslation}) => {
  const navigate = useNavigate();
  const t = useTranslation()
  const {language} = useLocale()

  const renderText = (value) => {
    const style = value.style ? value.style : {}
    return (
      <TextWrapper>
        {
          typeof value.text === "object" ?
            value.text.map((line, index) => (
              <ImageText key={index} style={style} center={centerText} small={smallText}>
                {line.includes("@") ? <a href={`mailto:${line}`}>{line}</a> : line}
              </ImageText>
            ))
            :
            (value.text || value.name) && (
              <ImageText style={style} center={centerText} small={smallText}>
                {textTranslation
                  ? value.translation
                    ? JSON.parse(value.translation)[language]
                    : t(textTranslation + (value.name || value.text))
                  : value.text || value.name}
              </ImageText>
            )
        }
      </TextWrapper>
    )
  }

  const getKeyIndex = (categoryId) => {
    navigate(`/subcategory/${categoryId}`)
  }

  const renderCells = () => object.map((value, index) => {
    const col = itemsPerRow
      ? <Col key={index} xs={24} sm={(24 / itemsPerRow) * (itemsPerRow / 2)} md={24 / itemsPerRow} style={wrapperStyle} onClick={type === "category" ? () => getKeyIndex(value.id) : null}>
          {value.textAbove && renderText(value)}
          <ImageWrapper center={centerImage}>
            {(value.src || value.image) && <img alt="MissingImage" src={value.src || value.image} style={imageStyle}/>}
          </ImageWrapper>
          {!value.textAbove && renderText(value)}
        </Col>
      : <Col key={index} style={wrapperStyle} onClick={type === "category" ? () => getKeyIndex(value.id) : null}>
          {value.textAbove && renderText(value)}
          <ImageWrapper center={centerImage}>
            {(value.src || value.image) && <img alt="MissingImage" src={value.src || value.image} style={imageStyle}/>}
          </ImageWrapper>
          {!value.textAbove && renderText(value)}
        </Col>
    return col
  })

  return (
    <GridWrapper>
      <Row justify="space-evenly">
        {renderCells()}
      </Row>
    </GridWrapper>
  )
}

export default ImageGrid
